export let isBrowser = typeof document !== 'undefined'

export const hasOwn = {}.hasOwnProperty
